<template>
  <v-menu
    open-on-hover
    offset-y
    :close-on-content-click="false"
    max-width="500"
  >
    <template #activator="{ on, attrs }">
      <span
        v-bind="attrs"
        v-on="on"
        v-if="rodadas.length > 0"
        class="ml-3 px-3 py-1 bra-5 d-inline-flex align-center"
        :style="badgeStyle"
      >
        <v-icon class="mr-1" size="18" color="#9810fa">$CalendarBlank</v-icon>
        {{ total }} rodada(s)
      </span>
    </template>

    <v-card class="pa-3" :style="cardStyle">
      <div v-if="total">
        <div
          v-for="(r, i) in primeiros"
          :key="i"
          class="text-body-2 py-1"
          style="width: 300px"
        >
          <div class="d-flex flex-column justify-space-between mb-2">
            <div class="font-weight-medium text-subtitle-2">
              <v-icon class="mr-1" size="20" color="#9810fa">$CalendarBlank</v-icon>
              {{ r.nome }}
            </div>

            <div
              style="width: fit-content;"
              class="d-inline-flex mt-2 px-2 bg-gray-300 text-gray-300 bra-5 font-12"
            >
              ID: {{ r.id }}
            </div>
          </div>

          <v-divider />

          <div
            style="background-color: #eff6ff; border: 1px #bedbff solid;"
            class="d-flex flex-column pa-2 bra-7 mt-2"
          >
            <div class="d-flex align-center font-weight-medium">
              <div
                style="width: 8px; height: 8px; background-color: #2b7fff"
                class="bra-15 mr-2"
              />
              Período de Referência
            </div>

            <div class="d-flex justify-space-between mt-2 w-80-porcento">
              <div class="d-flex flex-column">
                <span class="text-caption text--secondary">Início:</span>
                <span class="font-14">
                  {{ r.data_inicio_referencia }}
                </span>
              </div>

              <div class="d-flex flex-column text-right">
                <span class="text-caption text--secondary">Fim:</span>
                <span class="font-14">
                  {{ r.data_fim_referencia }}
                </span>
              </div>
            </div>
          </div>

          <div
            style="background-color: #f0fdf4; border: 1px #c0face solid;"
            class="d-flex flex-column pa-2 bra-7 mt-2"
          >
            <div class="d-flex align-center font-weight-medium">
              <div
                style="width: 8px; height: 8px; background-color: #00c950"
                class="bra-15 mr-2"
              />
              Período de Aplicação
            </div>

            <div class="d-flex justify-space-between mt-3 w-80-porcento">
              <div class="d-flex flex-column">
                <span class="text-caption text--secondary">Início:</span>
                <span class="font-14">
                  {{ r.data_inicio_aplicacao }}
                </span>
              </div>

              <div class="d-flex flex-column text-right">
                <span class="text-caption text--secondary">Fim:</span>
                <span class="font-14">
                  {{ r.data_fim_aplicacao }}
                </span>
              </div>
            </div>
          </div>

          <v-divider class="my-2"/>

          <div class="d-flex justify-space-between">
            <span class="d-flex align-center text-gray-300 font-11 text-truncate w-50-porcento">
              <v-icon size="16" class="mr-1">mdi-account-outline</v-icon>
              Usuário: {{ r.nome_usuario }}
            </span>
            <span class="d-flex align-center text-gray-300 font-11">
              <v-icon size="16" class="mr-1">$Clock</v-icon>
              {{ r.created_at.slice(0,16) }}
            </span>
          </div>
        </div>
      </div>

      <div v-else class="text-body-2">
        Nenhuma rodada vinculada.
      </div>
    </v-card>
  </v-menu>
</template>

<script setup>
import { computed } from "vue";
import moment from "moment";

const props = defineProps({
  rodadas: { type: Array, default: () => [] },
  limite: { type: Number, default: 10 },
  titulo: { type: String, default: "Id Grupo | Cod. Produto | Descrição" },
  cursor: { type: String, default: "pointer" },
  maxHeight: { type: [Number, String], default: 260 },
  produto_inicial: { type: Object, required: true },
});

const total = computed(() => (props.rodadas.length ? props.rodadas.length : 0));
const primeiros = computed(() => (props.rodadas || []).slice(0, props.limite));

const badgeStyle = computed(() =>
  `background-color: #f3e8ff; color: #9810fa; cursor: ${props.cursor};`
);

const cardStyle = computed(() => {
  const h = typeof props.maxHeight === "number" ? `${props.maxHeight}px` : props.maxHeight;
  return `max-height: ${h}; overflow: auto;`;
});

function toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;

  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}
</script>
